import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material';

import { TNKLoanSliderComponent } from './loan-slider.component';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { ApiRequestService } from '../../services/api-request.service';
import { AnalyticsService } from '../../services/analytics.service';
import { PlatformService } from '../../services/platform.services';
import { CookieService } from '../../services/cookie.service';
import { StorageService } from '../../services/storage.service';
export class TNKLoanSliderModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: TNKLoanSliderModule,
      providers: [],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    TNKUtilitiesModule,
    RouterModule,
  ],
  providers: [
    AnalyticsService,
    CookieService,
    ApiRequestService,
    PlatformService,
    StorageService,
  ],
  declarations: [TNKLoanSliderComponent],
  exports: [TNKLoanSliderComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKLoanSliderModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKLoanSliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKLoanSliderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
